import BadgeMask from '@/components/Badge/BadgeMask';
import Avatar from '@/components/Custom/Avatar';
import Box from '@/components/UI/Box';
import Chip from '@/components/UI/Chip';
import { type FragmentOf, graphql, readFragment } from '@/gql/graphql';

export const EventScorekeepingPanelBadgeItemFragment = graphql(
  /* GraphQL */ `
    fragment EventScorekeepingPanelBadgeItem on badge {
      id
      title
      color
      can_quick_assign
      attribute_score {
        id
        title
        default_numeric_value
      }
      badge_attributes(order_by: { order: asc }) {
        id
        title
        options
        is_required
        attribute_type
        default_value
      }
    }
  `,
);

function EventScorekeepingPanelBadgeItem({
  fragment,
  isChecked,
  onPress,
}: {
  fragment: FragmentOf<typeof EventScorekeepingPanelBadgeItemFragment>;
  isChecked: boolean;
  onPress: () => void;
}) {
  const badge = readFragment(EventScorekeepingPanelBadgeItemFragment, fragment);

  return (
    <Box mx="sm">
      <Chip onValueChange={onPress} value={isChecked} label={badge.title || ''}>
        <BadgeMask size="sm" color={badge.color}>
          <Avatar
            ring={false}
            size="sm"
            name={badge.title}
            color={badge.color}
          />
        </BadgeMask>
      </Chip>
    </Box>
  );
}

export default EventScorekeepingPanelBadgeItem;
